var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrivalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0007,
    cy: 13,
    rx: 13,
    ry: 13,
    fill: "#16A02C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34497 17.875C8.83715 17.875 8.40551 17.6973 8.05005 17.3418C7.69458 16.9863 7.51684 16.5547 7.51684 16.0469H6.2981V9.34375C6.2981 9.00859 6.41743 8.72168 6.6561 8.48301C6.89477 8.24434 7.18169 8.125 7.51684 8.125H16.0481V10.5625H17.8762L19.7043 13V16.0469H18.4856C18.4856 16.5547 18.3078 16.9863 17.9524 17.3418C17.5969 17.6973 17.1653 17.875 16.6575 17.875C16.1496 17.875 15.718 17.6973 15.3625 17.3418C15.0071 16.9863 14.8293 16.5547 14.8293 16.0469H11.1731C11.1731 16.5547 10.9954 16.9863 10.6399 17.3418C10.2844 17.6973 9.85278 17.875 9.34497 17.875ZM9.34497 16.6562C9.51762 16.6562 9.66235 16.5979 9.77914 16.4811C9.89594 16.3643 9.95434 16.2195 9.95434 16.0469C9.95434 15.8742 9.89594 15.7295 9.77914 15.6127C9.66235 15.4959 9.51762 15.4375 9.34497 15.4375C9.17231 15.4375 9.02758 15.4959 8.91079 15.6127C8.79399 15.7295 8.73559 15.8742 8.73559 16.0469C8.73559 16.2195 8.79399 16.3643 8.91079 16.4811C9.02758 16.5979 9.17231 16.6562 9.34497 16.6562ZM16.6575 16.6562C16.8301 16.6562 16.9748 16.5979 17.0916 16.4811C17.2084 16.3643 17.2668 16.2195 17.2668 16.0469C17.2668 15.8742 17.2084 15.7295 17.0916 15.6127C16.9748 15.4959 16.8301 15.4375 16.6575 15.4375C16.4848 15.4375 16.3401 15.4959 16.2233 15.6127C16.1065 15.7295 16.0481 15.8742 16.0481 16.0469C16.0481 16.2195 16.1065 16.3643 16.2233 16.4811C16.3401 16.5979 16.4848 16.6562 16.6575 16.6562ZM16.0481 13.6094H18.6379L17.2668 11.7812H16.0481V13.6094Z",
    fill: "#FFF536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalActive);
export default __webpack_public_path__ + "static/media/arrival_active.0fd94448e769bf6364007f348376756b.svg";
export { ForwardRef as ReactComponent };